import React from "react";
import { Icon } from "semantic-ui-react";

export default ({ usedSuspiciousCcys }) => {
  return (
    usedSuspiciousCcys &&
    usedSuspiciousCcys.length > 0 && (
      <Icon name="strikethrough" color="red" title={`Suspicious currencies used ${usedSuspiciousCcys}.`} />
    )
  );
};



// WEBPACK FOOTER //
// ./src/bot/SuspiciousCcysIcon.js